<template>
  <div class="flex-center fill-height">
    <v-card-text
      class="pb-0 fill-height d-flex flex-column justify-space-between"
    >
      <div>
        <div class="flex-center imagen-servicio">
          <v-img contain v-bind:src="require(`../../assets/img/${IMGurl}`)" />
        </div>

        <div class="text--disabled text-uppercase text-h5 my-2">
          {{ Titulo }}
        </div>
      </div>

      <div class="text-uppercase blue--text mx-5 my-2">{{ Descripcion }}</div>

      <div>
        <v-divider class="" />
        <div v-for="detalle of Detalles">
          <div class="text-uppercase blue--text my-2">{{ detalle }}</div>
          <v-divider />
        </div>
      </div>
    </v-card-text>
    <!--  <v-divider vertical style="margin-right:-23px" v-if="this.$vuetify.breakpoint.mdAndUp && (Index+1) % 3 !== 0 "></v-divider> -->
  </div>
</template>

<script>
export default {
  name: "Service",
  props: ["Titulo", "Descripcion", "IMGurl", "Detalles", "Index"],
};
</script>

<style lang="scss">
$main_color: #283e79;

ul {
  font-size: 13px;
  line-height: 1.5em;
  margin: 5px 0 15px;
  padding: 0;

  li {
    list-style: none;
    position: relative;
    padding: 0 0 0 20px;
  }

  li {
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 5px;
      width: 10px;
      height: 10px;
      background-color: $main_color;
      border-radius: 50%;
      -moz-border-radius: 50%;
      -webkit-eeborder-radius: 50%;
    }
  }
}
</style>

<style scoped>
.blue--text {
  color: #0d4e6c !important;
}
.header {
  background-color: #283e79;
  color: white;
}

.imagen-servicio {
  max-width: 300px;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
}

.circle1 {
  border-radius: 50%;
  width: 150px;
  height: 150px;
  background-color: #f0f8ff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.circle2 {
  border-radius: 50%;
  width: 100px;
  height: 100px;
  background-color: #e0effc;
  display: flex;
  align-items: center;
  justify-content: center;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.svg-border-rounded svg {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  color: #f4f7f5;
  z-index: -1;
}

#pricing {
  z-index: 0;
}

.content {
  z-index: 1;
}

svg {
  overflow: hidden;
}

section {
  position: relative;
}
</style>
